import { MagicStructureResponseData } from './magic-structure-response-data.model';

export class MagicFolderResponseData extends MagicStructureResponseData {
    public folderId: number;
}
